import { render, staticRenderFns } from "./diamondDetail.vue?vue&type=template&id=236c167a&scoped=true"
import script from "./diamondDetail.vue?vue&type=script&lang=js"
export * from "./diamondDetail.vue?vue&type=script&lang=js"
import style0 from "./diamondDetail.vue?vue&type=style&index=0&id=236c167a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c167a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236c167a')) {
      api.createRecord('236c167a', component.options)
    } else {
      api.reload('236c167a', component.options)
    }
    module.hot.accept("./diamondDetail.vue?vue&type=template&id=236c167a&scoped=true", function () {
      api.rerender('236c167a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/diamondDetail.vue"
export default component.exports